define("AragornAnalytics", [], function() { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 280);
/******/ })
/************************************************************************/
/******/ ({

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.installVuePlugin = installVuePlugin;
exports.ensureLeadingSlashes = ensureLeadingSlashes;
exports.validateEventProps = validateEventProps;
exports.formatHostOrDefault = formatHostOrDefault;
exports.safeClone = safeClone;

var _safeJsonStringify = __webpack_require__(59);

var _safeJsonStringify2 = _interopRequireDefault(_safeJsonStringify);

var _SystemError = __webpack_require__(7);

var _SystemError2 = _interopRequireDefault(_SystemError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Install Aragorn as a Vue Plugin.
 *
 * @param {AragornAnalytics|AragornLight} Aragorn - The class to initalize.
 * @param {Object} Vue - Vue instance to install the plugin to.
 * @param {AragornConfigObject} options - Install config passed to getInstance funciton.
 */
function installVuePlugin(Aragorn, Vue, options) {
  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$analytics = Aragorn.getInstance(options);
}

/**
 * Return the given URL ensuring it starts with `//`.
 *
 * @param {string} url - URL to modify.
 * @param {string} [protocol=''] - The protocal prefix.
 * @returns {string}
 */
function ensureLeadingSlashes(url) {
  var protocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var noProtocol = String(url).replace(/^(https?:)?(\/\/)?/, '');
  var prefix = protocol.length > 0 ? protocol + ':' : '';
  return prefix + '//' + noProtocol;
}

/**
 * Validate the given event properties and throw errors if they do not pass.
 *
 * @param {EventData} properties - The props to validate.
 * @throws {SystemError} If the props are not valid.
 */
function validateEventProps(properties) {
  if (properties == null) {
    throw new _SystemError2.default('Event properties must be passed');
  }
  if (properties.type == null) {
    throw new _SystemError2.default('Missing or null event type', properties);
  }
}

/**
 * Return the given host formatted or return the defaultHost formmatted.
 *
 * @param {string} host - The host to use if it exists.
 * @param {string} defaultHost - The host to use if host is null.
 * @param {string} protocol - The protocall to use.
 * @returns {string} - The fromatted host.
 */
function formatHostOrDefault(host, defaultHost, protocol) {
  if (host) {
    return ensureLeadingSlashes(host, protocol);
  }
  return ensureLeadingSlashes(defaultHost, protocol);
}

function safeClone(obj) {
  return JSON.parse((0, _safeJsonStringify2.default)(obj));
}

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function ExtendableError(message) {
  Object.defineProperty(this, 'name', {
    enumerable: false,
    writable: true,
    value: 'ExtendableError'
  });

  Object.defineProperty(this, 'message', {
    enumerable: false,
    writable: true,
    value: message
  });

  if (Error.captureStackTrace) {
    // V8
    Error.captureStackTrace(this, ExtendableError);
  } else {
    Object.defineProperty(this, 'stack', {
      enumerable: false,
      writable: false,
      value: new Error(message).stack
    });
  }
}

if (typeof Object.setPrototypeOf === 'function') {
  Object.setPrototypeOf(ExtendableError.prototype, Error.prototype);
} else {
  ExtendableError.prototype = Object.create(Error.prototype, {
    constructor: { value: ExtendableError }
  });
}

exports.default = ExtendableError;

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53);
module.exports = __webpack_require__(281);


/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lumberjack = __webpack_require__(55);

var _lumberjack2 = _interopRequireDefault(_lumberjack);

__webpack_require__(56);

var _EventQueue = __webpack_require__(57);

var _EventQueue2 = _interopRequireDefault(_EventQueue);

var _defaultConfig = __webpack_require__(58);

var _defaultConfig2 = _interopRequireDefault(_defaultConfig);

var _shared = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @example
 * const aa = AragornAnalytics.getInstance({
 *     host: 'https://www.weebly.com/',
 * });
 * aa.track({
 *     type: 'an-event',
 *     param: 'value',
 * });
 */
var AragornLight = function () {
  /**
   * @param {AragornConfigObject} config - The configuration to sue if a new instance is made.
   */
  function AragornLight() {
    var _this = this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AragornLight);

    /**
     * This lets us use the AragornAnalytics name space before
     * it has downloaded on external pages. When initializing the
     * the library it will check if the `full` library is loaded.
     * @type {Boolean}
     * @private
     */
    this.isFullLibrary = false;

    /**
     * This is the config that was used to initalize this light
     * version. When the full version starts it will read in
     * this config.
     * @type {AragornConfigObject}
     * @private
     */
    this.config = config;

    /**
     * This version is used by the static getInstance function
     * to ensure the versions running on the page are the same
     * version.
     * @type {string}
     * @private
     */
    this.version = "4.39.0";

    if (false) {
      /**
       * True if the build is development mode.
       * @type {Boolean}
       * @private
       */
      this.devBuild = true;
    }

    /**
     * A Queue to store event data in until it is time to fire them.
     * @type {EventQueue}
     */
    this.eventQueue = new _EventQueue2.default();

    /**
     * Should we queue events or reject them.
     * @type {Boolean}
     * @private
     */
    this.queueEvents = true; // Start in queueing state.

    /**
     * Boolean for when script finishes loading.
     * @type {Boolean}
     * @private
     */
    this.scriptFinishedLoading = false;

    /**
     * A promise which resolves when the script finishes loading.
     * @type {Promise}
     * @private
     */
    this.fullLibraryPromise = new Promise(function (resolve) {
      /**
       * Resolve the fullLibraryPromise.
       *
       * @type {Function}
       * @private
       */
      _this.resolveFullLibraryPromise = function () {
        resolve();
      };
    });

    /**
     * A promise which resolves with the page and user data when it is loaded.
     * @type {Promise}
     * @private
     */
    this.pageAndUserDataPromise = new Promise(function (resolve) {
      /**
       * Resolve the pageAndUserDataPromise.
       *
       * @type {Function}
       * @private
       */
      _this.resolvePageAndUserDataPromise = function () {
        // Remove this resolver so that it is not called again.
        // If the full library takes over after the timeout
        // it will create a new promise because this would
        // have been resolved.
        _this.resolvePageAndUserDataPromise = null;
        resolve.apply(undefined, arguments);
      };
    });

    // We are not using AragornLumberjack here because it is too big.
    /**
     * We need a logger to handle logs
     *
     * @type {Lumberjack}
     * @private
     */
    this.logger = _lumberjack2.default.getInstance({
      host: this.config.host,
      project: 'AragornAnalytics',
      release: "4.39.0"
    });

    // Timeout for full library taking control
    setTimeout(function () {
      if (!window.AragornAnalytics.isFullLibrary) {
        _this.queueEvents = false;
        _this.eventQueue.flush();
        // If the full library times out then resolve this with the default data.
        if (typeof _this.resolvePageAndUserDataPromise === 'function') {
          _this.resolvePageAndUserDataPromise(_extends({}, _this.config.pageAndUserData));
        }
        _this.logger.warn('Full Library failed to take control before timeout was hit.', {
          'script finished loading': _this.scriptFinishedLoading
        });
      }
    }, 5000);

    this.downloadLibrary();
  }

  /**
   * Initiate the download of the full library.
   *
   * @private
   */


  _createClass(AragornLight, [{
    key: 'downloadLibrary',
    value: function downloadLibrary() {
      var head = document.getElementsByTagName('head')[0];
      var FullAragornScript = document.createElement('script');

      var callback = this.resolveFullLibraryPromise;
      var AragornInstance = this;

      function checkDone() {
        if (AragornInstance.scriptFinishedLoading) {
          return;
        }

        var scriptTag = this;
        if (!scriptTag.readyState || scriptTag.readyState === 'loaded' || scriptTag.readyState === 'complete') {
          AragornInstance.scriptFinishedLoading = true;

          callback();

          // Handle memory leak in IE
          FullAragornScript.onload = null;
          FullAragornScript.onreadystatechange = null;
        }
      }

      // Need both functions because of IE.
      FullAragornScript.onload = checkDone;
      FullAragornScript.onreadystatechange = checkDone;

      FullAragornScript.setAttribute('type', 'text/javascript');
      FullAragornScript.setAttribute('src', "//cdn2.editmysite.com/javascript/aragorn-analytics-4.39.0.js");

      head.appendChild(FullAragornScript);
    }

    /**
     * Re-Initialize the full library or wait for full library to take over.
     *
     * @returns {Promise}
     */

  }, {
    key: 'initialize',
    value: function initialize() {
      if (window.AragornAnalytics && window.AragornAnalytics.isFullLibrary) {
        return window.AragornAnalytics.initialize();
      }
      return this.fullLibraryPromise;
    }

    /**
     * Track an event, either by using the now downloaded full library or storing it in a queue.
     *
     * @param {EventData} properties - Properties of the event.
     * @returns {Promise.<boolean>} Tracking was successful.
     */

  }, {
    key: 'track',
    value: function track(properties) {
      var _this2 = this;

      if (window.AragornAnalytics && window.AragornAnalytics.isFullLibrary) {
        return window.AragornAnalytics.track(properties);
      }
      if (this.queueEvents) {
        return Promise.resolve().then(function () {
          return (0, _shared.validateEventProps)(properties);
        }).then(function () {
          return _this2.eventQueue.enqueue(properties);
        }).catch(function (error) {
          if (error) {
            _this2.logger.error(error);
          }
          return false; // the event was not tracked
        });
      }
      // The full library failed to load.
      // Now we reject any event sent to us.
      return Promise.resolve(false);
    }

    /**
     * Get the page and user data object once it is loaded.
     *
     * @returns {Promise<Object>} The data.
     */

  }, {
    key: 'getPageAndUserData',
    value: function getPageAndUserData() {
      return this.pageAndUserDataPromise;
    }

    /**
     * Returns the current instance.
     *
     * @returns {AragornLight|AragornAnalytics}
     */

  }, {
    key: 'getInstance',
    value: function getInstance() {
      if (window.AragornAnalytics && window.AragornAnalytics.isFullLibrary) {
        return window.AragornAnalytics;
      }
      return this;
    }

    /**
     * Get an instance of the AragornAnalytics Library. There will only be one instance per page.
     *
     * @param {AragornConfigObject} config - The configuration to sue if a new instance is made.
     * @returns {AragornLight|AragornAnalytics} An instance of this class.
     */

  }], [{
    key: 'getInstance',
    value: function getInstance() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (window.AragornAnalytics) {
        return window.AragornAnalytics;
      }
      var configInternal = (0, _defaultConfig2.default)(config);

      var aa = new AragornLight(configInternal);
      window.AragornAnalytics = aa;
      return aa;
    }

    /**
     * Install Aragorn as a Vue Plugin.
     *
     * @param {Object} Vue - Vue instance to install the plugin to.
     * @param {AragornConfigObject} options - Install config passed to getInstance funciton.
     */

  }, {
    key: 'install',
    value: function install(Vue, options) {
      (0, _shared.installVuePlugin)(this, Vue, options);
    }
  }]);

  return AragornLight;
}();

exports.default = AragornLight;

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function () {
    return [];
};

process.binding = function () {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function () {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function () {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(54);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || undefined && undefined.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || undefined && undefined.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/

(function (name, context, definition) {
	// special form of UMD for polyfilling across evironments
	context[name] = context[name] || definition();
	if (typeof module != "undefined" && module.exports) {
		module.exports = context[name];
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return context[name];
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
})("Promise", typeof global != "undefined" ? global : undefined, function () {
	/*jshint validthis:true */
	"use strict";

	var builtInProp,
	    cycle,
	    scheduling_queue,
	    ToString = Object.prototype.toString,
	    timer = typeof setImmediate != "undefined" ? function (fn) {
		return setImmediate(fn);
	} : setTimeout;

	// dammit, IE8.
	try {
		Object.defineProperty({}, "x", {});
		builtInProp = function (obj, name, val, config) {
			return Object.defineProperty(obj, name, {
				value: val,
				writable: true,
				configurable: config !== false
			});
		};
	} catch (err) {
		builtInProp = function (obj, name, val) {
			obj[name] = val;
			return obj;
		};
	}

	// Note: using a queue instead of array for efficiency
	scheduling_queue = function () {
		var first, last, item;

		function Item(fn, self) {
			this.fn = fn;
			this.self = self;
			this.next = void 0;
		}

		return {
			add: function (fn, self) {
				item = new Item(fn, self);
				if (last) {
					last.next = item;
				} else {
					first = item;
				}
				last = item;
				item = void 0;
			},
			drain: function () {
				var f = first;
				first = last = cycle = void 0;

				while (f) {
					f.fn.call(f.self);
					f = f.next;
				}
			}
		};
	}();

	function schedule(fn, self) {
		scheduling_queue.add(fn, self);
		if (!cycle) {
			cycle = timer(scheduling_queue.drain);
		}
	}

	// promise duck typing
	function isThenable(o) {
		var _then,
		    o_type = typeof o === "undefined" ? "undefined" : _typeof(o);

		if (o != null && (o_type == "object" || o_type == "function")) {
			_then = o.then;
		}
		return typeof _then == "function" ? _then : false;
	}

	function notify() {
		for (var i = 0; i < this.chain.length; i++) {
			notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
		}
		this.chain.length = 0;
	}

	// NOTE: This is a separate function to isolate
	// the `try..catch` so that other code can be
	// optimized better
	function notifyIsolated(self, cb, chain) {
		var ret, _then;
		try {
			if (cb === false) {
				chain.reject(self.msg);
			} else {
				if (cb === true) {
					ret = self.msg;
				} else {
					ret = cb.call(void 0, self.msg);
				}

				if (ret === chain.promise) {
					chain.reject(TypeError("Promise-chain cycle"));
				} else if (_then = isThenable(ret)) {
					_then.call(ret, chain.resolve, chain.reject);
				} else {
					chain.resolve(ret);
				}
			}
		} catch (err) {
			chain.reject(err);
		}
	}

	function resolve(msg) {
		var _then,
		    self = this;

		// already triggered?
		if (self.triggered) {
			return;
		}

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		try {
			if (_then = isThenable(msg)) {
				schedule(function () {
					var def_wrapper = new MakeDefWrapper(self);
					try {
						_then.call(msg, function () {
							resolve.apply(def_wrapper, arguments);
						}, function () {
							reject.apply(def_wrapper, arguments);
						});
					} catch (err) {
						reject.call(def_wrapper, err);
					}
				});
			} else {
				self.msg = msg;
				self.state = 1;
				if (self.chain.length > 0) {
					schedule(notify, self);
				}
			}
		} catch (err) {
			reject.call(new MakeDefWrapper(self), err);
		}
	}

	function reject(msg) {
		var self = this;

		// already triggered?
		if (self.triggered) {
			return;
		}

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		self.msg = msg;
		self.state = 2;
		if (self.chain.length > 0) {
			schedule(notify, self);
		}
	}

	function iteratePromises(Constructor, arr, resolver, rejecter) {
		for (var idx = 0; idx < arr.length; idx++) {
			(function (idx) {
				Constructor.resolve(arr[idx]).then(function (msg) {
					resolver(idx, msg);
				}, rejecter);
			})(idx);
		}
	}

	function MakeDefWrapper(self) {
		this.def = self;
		this.triggered = false;
	}

	function MakeDef(self) {
		this.promise = self;
		this.state = 0;
		this.triggered = false;
		this.chain = [];
		this.msg = void 0;
	}

	function Promise(executor) {
		if (typeof executor != "function") {
			throw TypeError("Not a function");
		}

		if (this.__NPO__ !== 0) {
			throw TypeError("Not a promise");
		}

		// instance shadowing the inherited "brand"
		// to signal an already "initialized" promise
		this.__NPO__ = 1;

		var def = new MakeDef(this);

		this["then"] = function (success, failure) {
			var o = {
				success: typeof success == "function" ? success : true,
				failure: typeof failure == "function" ? failure : false
			};
			// Note: `then(..)` itself can be borrowed to be used against
			// a different promise constructor for making the chained promise,
			// by substituting a different `this` binding.
			o.promise = new this.constructor(function (resolve, reject) {
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}

				o.resolve = resolve;
				o.reject = reject;
			});
			def.chain.push(o);

			if (def.state !== 0) {
				schedule(notify, def);
			}

			return o.promise;
		};
		this["catch"] = function (failure) {
			return this.then(void 0, failure);
		};

		try {
			executor.call(void 0, function (msg) {
				resolve.call(def, msg);
			}, function (msg) {
				reject.call(def, msg);
			});
		} catch (err) {
			reject.call(def, err);
		}
	}

	var PromisePrototype = builtInProp({}, "constructor", Promise,
	/*configurable=*/false);

	// Note: Android 4 cannot use `Object.defineProperty(..)` here
	Promise.prototype = PromisePrototype;

	// built-in "brand" to signal an "uninitialized" promise
	builtInProp(PromisePrototype, "__NPO__", 0,
	/*configurable=*/false);

	builtInProp(Promise, "resolve", function (msg) {
		var Constructor = this;

		// spec mandated checks
		// note: best "isPromise" check that's practical for now
		if (msg && (typeof msg === "undefined" ? "undefined" : _typeof(msg)) == "object" && msg.__NPO__ === 1) {
			return msg;
		}

		return new Constructor(function (resolve, reject) {
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			resolve(msg);
		});
	});

	builtInProp(Promise, "reject", function (msg) {
		return new this(function (resolve, reject) {
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			reject(msg);
		});
	});

	builtInProp(Promise, "all", function (arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}
		if (arr.length === 0) {
			return Constructor.resolve([]);
		}

		return new Constructor(function (resolve, reject) {
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			var len = arr.length,
			    msgs = Array(len),
			    count = 0;

			iteratePromises(Constructor, arr, function (idx, msg) {
				msgs[idx] = msg;
				if (++count === len) {
					resolve(msgs);
				}
			}, reject);
		});
	});

	builtInProp(Promise, "race", function (arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}

		return new Constructor(function (resolve, reject) {
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			iteratePromises(Constructor, arr, function (idx, msg) {
				resolve(msg);
			}, reject);
		});
	});

	return Promise;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(43).setImmediate))

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function (handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function (event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function (handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function (handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function (handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function (handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (function () {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(32)))

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (root, factory) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["Lumberjack"] = factory();else root["Lumberjack"] = factory();
})(typeof self !== 'undefined' ? self : undefined, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function () {
          return module['default'];
        } :
        /******/function () {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 0);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports, __webpack_require__) {

      __webpack_require__(1);
      module.exports = __webpack_require__(2);

      /***/
    },
    /* 1 */
    /***/function () {

      "use strict";

      (function (self) {

        if (self.fetch) {
          return;
        }

        var support = {
          searchParams: 'URLSearchParams' in self,
          iterable: 'Symbol' in self && 'iterator' in Symbol,
          blob: 'FileReader' in self && 'Blob' in self && function () {
            try {
              new Blob();
              return true;
            } catch (e) {
              return false;
            }
          }(),
          formData: 'FormData' in self,
          arrayBuffer: 'ArrayBuffer' in self
        };

        if (support.arrayBuffer) {
          var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

          var isDataView = function (obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
          };

          var isArrayBufferView = ArrayBuffer.isView || function (obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
          };
        }

        function normalizeName(name) {
          if (typeof name !== 'string') {
            name = String(name);
          }
          if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
            throw new TypeError('Invalid character in header field name');
          }
          return name.toLowerCase();
        }

        function normalizeValue(value) {
          if (typeof value !== 'string') {
            value = String(value);
          }
          return value;
        }

        // Build a destructive iterator for the value list
        function iteratorFor(items) {
          var iterator = {
            next: function () {
              var value = items.shift();
              return { done: value === undefined, value: value };
            }
          };

          if (support.iterable) {
            iterator[Symbol.iterator] = function () {
              return iterator;
            };
          }

          return iterator;
        }

        function Headers(headers) {
          this.map = {};

          if (headers instanceof Headers) {
            headers.forEach(function (value, name) {
              this.append(name, value);
            }, this);
          } else if (Array.isArray(headers)) {
            headers.forEach(function (header) {
              this.append(header[0], header[1]);
            }, this);
          } else if (headers) {
            Object.getOwnPropertyNames(headers).forEach(function (name) {
              this.append(name, headers[name]);
            }, this);
          }
        }

        Headers.prototype.append = function (name, value) {
          name = normalizeName(name);
          value = normalizeValue(value);
          var oldValue = this.map[name];
          this.map[name] = oldValue ? oldValue + ',' + value : value;
        };

        Headers.prototype['delete'] = function (name) {
          delete this.map[normalizeName(name)];
        };

        Headers.prototype.get = function (name) {
          name = normalizeName(name);
          return this.has(name) ? this.map[name] : null;
        };

        Headers.prototype.has = function (name) {
          return this.map.hasOwnProperty(normalizeName(name));
        };

        Headers.prototype.set = function (name, value) {
          this.map[normalizeName(name)] = normalizeValue(value);
        };

        Headers.prototype.forEach = function (callback, thisArg) {
          for (var name in this.map) {
            if (this.map.hasOwnProperty(name)) {
              callback.call(thisArg, this.map[name], name, this);
            }
          }
        };

        Headers.prototype.keys = function () {
          var items = [];
          this.forEach(function (value, name) {
            items.push(name);
          });
          return iteratorFor(items);
        };

        Headers.prototype.values = function () {
          var items = [];
          this.forEach(function (value) {
            items.push(value);
          });
          return iteratorFor(items);
        };

        Headers.prototype.entries = function () {
          var items = [];
          this.forEach(function (value, name) {
            items.push([name, value]);
          });
          return iteratorFor(items);
        };

        if (support.iterable) {
          Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        }

        function consumed(body) {
          if (body.bodyUsed) {
            return Promise.reject(new TypeError('Already read'));
          }
          body.bodyUsed = true;
        }

        function fileReaderReady(reader) {
          return new Promise(function (resolve, reject) {
            reader.onload = function () {
              resolve(reader.result);
            };
            reader.onerror = function () {
              reject(reader.error);
            };
          });
        }

        function readBlobAsArrayBuffer(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          reader.readAsArrayBuffer(blob);
          return promise;
        }

        function readBlobAsText(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          reader.readAsText(blob);
          return promise;
        }

        function readArrayBufferAsText(buf) {
          var view = new Uint8Array(buf);
          var chars = new Array(view.length);

          for (var i = 0; i < view.length; i++) {
            chars[i] = String.fromCharCode(view[i]);
          }
          return chars.join('');
        }

        function bufferClone(buf) {
          if (buf.slice) {
            return buf.slice(0);
          } else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
          }
        }

        function Body() {
          this.bodyUsed = false;

          this._initBody = function (body) {
            this._bodyInit = body;
            if (!body) {
              this._bodyText = '';
            } else if (typeof body === 'string') {
              this._bodyText = body;
            } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
              this._bodyBlob = body;
            } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
              this._bodyFormData = body;
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this._bodyText = body.toString();
            } else if (support.arrayBuffer && support.blob && isDataView(body)) {
              this._bodyArrayBuffer = bufferClone(body.buffer);
              // IE 10-11 can't handle a DataView body.
              this._bodyInit = new Blob([this._bodyArrayBuffer]);
            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
              this._bodyArrayBuffer = bufferClone(body);
            } else {
              throw new Error('unsupported BodyInit type');
            }

            if (!this.headers.get('content-type')) {
              if (typeof body === 'string') {
                this.headers.set('content-type', 'text/plain;charset=UTF-8');
              } else if (this._bodyBlob && this._bodyBlob.type) {
                this.headers.set('content-type', this._bodyBlob.type);
              } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
              }
            }
          };

          if (support.blob) {
            this.blob = function () {
              var rejected = consumed(this);
              if (rejected) {
                return rejected;
              }

              if (this._bodyBlob) {
                return Promise.resolve(this._bodyBlob);
              } else if (this._bodyArrayBuffer) {
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              } else if (this._bodyFormData) {
                throw new Error('could not read FormData body as blob');
              } else {
                return Promise.resolve(new Blob([this._bodyText]));
              }
            };

            this.arrayBuffer = function () {
              if (this._bodyArrayBuffer) {
                return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
              } else {
                return this.blob().then(readBlobAsArrayBuffer);
              }
            };
          }

          this.text = function () {
            var rejected = consumed(this);
            if (rejected) {
              return rejected;
            }

            if (this._bodyBlob) {
              return readBlobAsText(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
            } else if (this._bodyFormData) {
              throw new Error('could not read FormData body as text');
            } else {
              return Promise.resolve(this._bodyText);
            }
          };

          if (support.formData) {
            this.formData = function () {
              return this.text().then(decode);
            };
          }

          this.json = function () {
            return this.text().then(JSON.parse);
          };

          return this;
        }

        // HTTP methods whose capitalization should be normalized
        var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

        function normalizeMethod(method) {
          var upcased = method.toUpperCase();
          return methods.indexOf(upcased) > -1 ? upcased : method;
        }

        function Request(input, options) {
          options = options || {};
          var body = options.body;

          if (input instanceof Request) {
            if (input.bodyUsed) {
              throw new TypeError('Already read');
            }
            this.url = input.url;
            this.credentials = input.credentials;
            if (!options.headers) {
              this.headers = new Headers(input.headers);
            }
            this.method = input.method;
            this.mode = input.mode;
            if (!body && input._bodyInit != null) {
              body = input._bodyInit;
              input.bodyUsed = true;
            }
          } else {
            this.url = String(input);
          }

          this.credentials = options.credentials || this.credentials || 'omit';
          if (options.headers || !this.headers) {
            this.headers = new Headers(options.headers);
          }
          this.method = normalizeMethod(options.method || this.method || 'GET');
          this.mode = options.mode || this.mode || null;
          this.referrer = null;

          if ((this.method === 'GET' || this.method === 'HEAD') && body) {
            throw new TypeError('Body not allowed for GET or HEAD requests');
          }
          this._initBody(body);
        }

        Request.prototype.clone = function () {
          return new Request(this, { body: this._bodyInit });
        };

        function decode(body) {
          var form = new FormData();
          body.trim().split('&').forEach(function (bytes) {
            if (bytes) {
              var split = bytes.split('=');
              var name = split.shift().replace(/\+/g, ' ');
              var value = split.join('=').replace(/\+/g, ' ');
              form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
          });
          return form;
        }

        function parseHeaders(rawHeaders) {
          var headers = new Headers();
          // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
          // https://tools.ietf.org/html/rfc7230#section-3.2
          var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
          preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
            var parts = line.split(':');
            var key = parts.shift().trim();
            if (key) {
              var value = parts.join(':').trim();
              headers.append(key, value);
            }
          });
          return headers;
        }

        Body.call(Request.prototype);

        function Response(bodyInit, options) {
          if (!options) {
            options = {};
          }

          this.type = 'default';
          this.status = options.status === undefined ? 200 : options.status;
          this.ok = this.status >= 200 && this.status < 300;
          this.statusText = 'statusText' in options ? options.statusText : 'OK';
          this.headers = new Headers(options.headers);
          this.url = options.url || '';
          this._initBody(bodyInit);
        }

        Body.call(Response.prototype);

        Response.prototype.clone = function () {
          return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url
          });
        };

        Response.error = function () {
          var response = new Response(null, { status: 0, statusText: '' });
          response.type = 'error';
          return response;
        };

        var redirectStatuses = [301, 302, 303, 307, 308];

        Response.redirect = function (url, status) {
          if (redirectStatuses.indexOf(status) === -1) {
            throw new RangeError('Invalid status code');
          }

          return new Response(null, { status: status, headers: { location: url } });
        };

        self.Headers = Headers;
        self.Request = Request;
        self.Response = Response;

        self.fetch = function (input, init) {
          return new Promise(function (resolve, reject) {
            var request = new Request(input, init);
            var xhr = new XMLHttpRequest();

            xhr.onload = function () {
              var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || '')
              };
              options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
              var body = 'response' in xhr ? xhr.response : xhr.responseText;
              resolve(new Response(body, options));
            };

            xhr.onerror = function () {
              reject(new TypeError('Network request failed'));
            };

            xhr.ontimeout = function () {
              reject(new TypeError('Network request failed'));
            };

            xhr.open(request.method, request.url, true);

            if (request.credentials === 'include') {
              xhr.withCredentials = true;
            } else if (request.credentials === 'omit') {
              xhr.withCredentials = false;
            }

            if ('responseType' in xhr && support.blob) {
              xhr.responseType = 'blob';
            }

            request.headers.forEach(function (value, name) {
              xhr.setRequestHeader(name, value);
            });

            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
          });
        };
        self.fetch.polyfill = true;
      })(typeof self !== 'undefined' ? self : undefined);

      /***/
    },
    /* 2 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _defaultConfig = __webpack_require__(3);

      var _defaultConfig2 = function (obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }(_defaultConfig);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      /**
       * @private
       * @typedef {Object} treeInternal
       * @property {string} message - The message to send in the logs
       * @property {string} [level='error'] - The level of the log.
       * @property {any} extra - Any extra data to pass to logging system.
       */

      /**
       * @typedef {Object} tree
       * @property {string} message - The message to send in the logs
       * @property {any} extra - Any extra data to pass to logging system.
       */

      /**
       * @typedef {Promise<boolean>} logResponse - The response from a log request
       * @return {boolean} The success of the logging operation.
       */

      /**
       * Lumberjack is a logger to log logs via a route
       * in the monolith to Kibana.
       *
       * @example
       * const logger = Lumberjack.getInstance({
       *     project: 'AragornAnalytics',
       *     release: '1.1.0', // This should be based on your package.json (process.env.VERSION)
       *     host: 'https://www.weebly.com/',
       * });
       *
       * logger.warn({
       *     message: 'There was a thing, it might be bad',
       *     extra: {
       *         thing: 'might be bad',
       *     }
       * });
       *
       * Vue.use(Lumberjack, {
       *     project: 'AragornAnalytics',
       *     release: '1.1.0', // This should be based on your package.json (process.env.VERSION)
       *     host: 'https://www.weebly.com/',
       * });
       *
       * this.$logger.warn({
       *     message: 'There was a thing, it might be bad',
       *     extra: {
       *         thing: 'might be bad',
       *     }
       * });
       */
      var Lumberjack = function () {
        /**
         * @param {Object} props - The event Props.
         * @param {string} props.project - The name of the project doing the logging.
         * @param {string} props.logURL - The fully qualified URL to use for logging.
         */
        function Lumberjack(props) {
          _classCallCheck(this, Lumberjack);

          /**
           * The name of the project doing the logging.
           * @type {string}
           * @private
           */
          this.project = props.project;

          /**
           * The release of the project doing the logging.
           * @type {string}
           * @private
           */
          this.release = props.release;

          /**
           * The fully qualified URL to use for logging.
           * @type {string}
           * @private
           */
          this.logURL = props.logURL;
        }

        /**
         * The actual log method, don't use this.
         *
         * @private
         *
         * @param {treeInternal} tree - The item to log.
         * @returns {logResponse} The logging is done.
         */

        _createClass(Lumberjack, [{
          key: 'log',
          value: function (_ref) {
            var message = _ref.message,
                level = _ref.level,
                extra = _ref.extra;

            var payload = {
              jsonrpc: '2.0',
              method: 'Logger::log',
              params: {
                level: [Lumberjack.INFO, Lumberjack.WARNING].includes(level) ? level : Lumberjack.ERROR,
                culprit: window.location.href,
                message: message,
                logger: 'javascript',
                project: this.project,
                release: this.release,
                extra: extra
              }
            };

            return fetch(this.logURL, {
              method: 'POST',
              mode: 'no-cors',
              body: JSON.stringify(payload)
            }).then(function () {
              return true;
            })
            // We don't care about errors from the logging system,
            // Where would we even send them?
            .catch(function () {
              return false;
            });
          }

          /**
           * @private
           * @param {string} level - The level of the log.
           * @param {tree} [tree={}] - The tree to log.
           * @returns {logResponse}
           */

        }, {
          key: 'logTree',
          value: function (level, tree) {
            var innerTree = tree || {};
            innerTree.level = level;
            return this.log(innerTree);
          }

          /**
           * Log an error level log.
           *
           * @param {tree|string} tree - The tree to log.
           * @returns {logResponse}
           */

        }, {
          key: 'info',
          value: function (tree) {
            if (typeof tree === 'string') {
              return this.logTree(Lumberjack.INFO, { message: tree });
            }
            return this.logTree(Lumberjack.INFO, tree);
          }

          /**
           * Log an error level log.
           *
           * @param {tree|string} tree - The tree to log.
           * @returns {logResponse}
           */

        }, {
          key: 'warn',
          value: function (tree) {
            if (typeof tree === 'string') {
              return this.logTree(Lumberjack.WARNING, { message: tree });
            }
            return this.logTree(Lumberjack.WARNING, tree);
          }

          /**
           * Log an error level log.
           *
           * @param {tree|Error|string} tree - The tree to log.
           * @returns {logResponse}
           */

        }, {
          key: 'error',
          value: function (tree) {
            if (typeof tree === 'string') {
              return this.logTree(Lumberjack.ERROR, new Error(tree));
            }
            return this.logTree(Lumberjack.ERROR, tree);
          }

          /**
           * Set the global namespace for the logger instances.
           * This allows extending the class and making your own
           * set of global instances.
           */

        }], [{
          key: 'getInstance',

          /**
           * Create or get and instance of Lumberjack.
           * The existences of an instance will be based on the config.
           *
           * @param {LumberjackConfig} [config={}] - The config to use when finding a lumberjack to use.
           * @returns {Lumberjack}
           */
          value: function () {
            var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var innerConfig = {};
            if (config.fqurl) {
              innerConfig.logURL = config.fqurl;
            } else {
              // create the fqurl from parts
              innerConfig.logURL = (config.host || _defaultConfig2.default.host) + '/' + (config.path || _defaultConfig2.default.path);
            }
            // copy over the project name and release.
            innerConfig.project = config.project;
            innerConfig.release = config.release;

            var cacheKey = JSON.stringify(innerConfig);
            window[this.namespace] = window[this.namespace] || {};

            // check if there is an instance already.
            if (!window[this.namespace][cacheKey]) {
              // create a new instance.
              window[this.namespace][cacheKey] = new this(innerConfig);
            }
            return window[this.namespace][cacheKey];
          }

          /**
           * Install Lumberjack as a Vue Plugin.
           *
           * @param {Object} Vue - Vue instance to install the plugin to.
           * @param {LumberjackConfig} [options={}] - Install config passed to getInstance function.
           */

        }, {
          key: 'install',
          value: function (Vue, options) {
            // eslint-disable-next-line no-param-reassign
            Vue.prototype.$logger = this.getInstance(options);
          }
        }, {
          key: 'namespace',
          get: function () {
            return 'Lumberjacks';
          }
        }]);

        return Lumberjack;
      }();

      Lumberjack.INFO = 'info';
      Lumberjack.WARNING = 'warning';
      Lumberjack.ERROR = 'error';

      exports.default = Lumberjack;

      /***/
    },
    /* 3 */
    /***/function (module, exports) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      /**
       * @typedef {Object} LumberjackConfig
       *
       * if you set the fqurl it will overwrite the host and path.
       *
       * @property {string} project - The name of the project doing the logging.
       * @property {string} release - The release version of the project doing the logging.
       * @property {string} [host='https://www.weebly.com'] - The Host to log too.
       * @property {string} [path='/api/JsonRPC/Ocular?Ocular[Logger::log]'] - The path to log too.
       * @property {string} [fqurl] - The optional full path to use for logging.
       */

      /**
       * @type {LumberjackConfig}
       */


      exports.default = {
        project: null,
        release: null,
        host: 'https://www.weebly.com',
        path: '/api/JsonRPC/Ocular?Ocular[Logger::log]',
        fqurl: null
      };

      /***/
    }]
    /******/)
  );
});
//# sourceMappingURL=main.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)(module)))

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!(window.console && window.console.log)) {
  window.console = {
    log: function log() {},
    debug: function debug() {},
    info: function info() {},
    warn: function warn() {},
    error: function error() {}
  };
}

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventQueue = function () {
  /**
   * Queue Events for later tracking.
   */
  function EventQueue() {
    _classCallCheck(this, EventQueue);

    this.queue = [];
  }

  /**
   * @typedef {Object} eventQueueObject
   * @property {string} eventName The trigger for the event
   * @property {Object} properties The props passed when tracking the event
   * @property {function} resolve Resolve the event's promise
   * @property {function} reject Reject the event's promise
   */

  /**
   * Add an event to the queue.
   *
   * @param {EventData} properties - The props passed when tracking the event.
   * @returns {Promise}
   */


  _createClass(EventQueue, [{
    key: "enqueue",
    value: function enqueue(properties) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.queue.push({
          properties: properties,
          resolve: resolve,
          reject: reject
        });
      });
    }

    /**
     * @returns {eventQueueObject} Event (eventName, properties, resolve, reject).
     */

  }, {
    key: "dequeue",
    value: function dequeue() {
      return this.queue.shift();
    }

    /**
     * @returns {boolean} The queue has more than 0.
     */

  }, {
    key: "hasMore",
    value: function hasMore() {
      return this.queue.length > 0;
    }

    /**
     * Process and remove all events from the queue.
     *
     * @param {Function} processor - Can return a promise when done.
     * @returns {Promise}
     */

  }, {
    key: "empty",
    value: function empty(processor) {
      var promises = [];
      while (this.hasMore()) {
        promises.push(processor(this.dequeue()));
      }
      return Promise.all(promises);
    }

    /**
     * Remove all events from queue and reject their promises.
     *
     * @returns {Promise}
     */

  }, {
    key: "flush",
    value: function flush() {
      return this.empty(function (event) {
        var reject = event.reject;

        reject();
      });
    }
  }]);

  return EventQueue;
}();

exports.default = EventQueue;

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = cloneAndMergeConfig;

var _shared = __webpack_require__(26);

/**
 * @typedef {Object} AragornConfigObject - An object of config options.
 *
 * @property {boolean} [enableGTM = true] - Initialize the GTM service.
 * @property {boolean} [enableSnowplow=true] - Initialize the Snowplow service.
 * @property {boolean} [enableAmplitude=true] - Initialize the Amplitude service.
 * @property {boolean} [enableIterable=true] - Initialize the Iterable service.
 *
 * @property {string} [host='www.weebly.com'] - The Weebly Host used for all calls.
 *
 * @property {Object} [api] - API Settings
 * @property {string} [api.host='www.weebly.com'] - The Host to use for the API calls (defaults to main host prop).
 * @property {string} [api.path='/tracking/v2/gtmdata'] - The path to use for the API calls.
 *
 * @property {Object} [bridge] - Bridge Connection Settings
 * @property {string} [bridge.parent='www.weebly.com'] - The Host to use for the Parent from in Bridge Connections (defaults to main host prop).
 * @property {string} [bridge.child='www.weebly.com'] - The Host to use for the Child from in Bridge Connections (defaults to main host prop).
 *
 * @property {Object} [pageAndUserData] - Data about the page, will be merged with api user data.
 * @property {string} [pageAndUserData.pageError=''] - Any error message about the page.
 * @property {boolean} [pageRequiresSignIn=false] - This page is behind a login wall.
 * @property {boolean} [ignoreIFrame=false] - Ignore the iframe state and initialize library.
 * @property {boolean} [debug=false] - Initialize the library in a debug state.
 * @property {number} [timeout=5000] - Event tracking timeout.
 * @property {boolean} [throwErrorsInDebug=true] - When in debug mode, throw errors rather than just logging.
 * @property {string} [throwErrorsGuard='weebly.com'] - Before throwing any errors, the window.host will be compared to this string and if it matches the error will not be thrown.
 * @property {boolean} [enableSnowplowInIFrame=false] - Initialize an instance of snowplow regardless of iframe check.
 * @property {string} [sentryDNS='weebly-key'] - If set this will track specific errors to Sentry.
 *
 * @property {string[]} [containers] - An array of GTM Container IDs to use.
 * @property {string} [dataLayer='webLayer'] - The key value for the GTM global event array.
 *
 * @property {string} [snowplowName='_wsp'] - The global name for our Snowplow instance.
 * @property {string} [snowplowNamespace='_w'] - The Snowplow namespace, sent with each event.
 * @property {string} [snowplowAppID='w1'] - The Snowplow namespace, sent with each event.
 * @property {string} [snowplowUserIDFields='userID,duid'] - The API fields that snowplow should use for a user_id, they are `,` seperated and can have `/` for nested values.
 *
 * @property {string} [amplitudeKey='<the key>'] - The project key for Amplitude.
 * @property {string} [amplitudeUserIDFields='userID'] - The API fields that amplitude should use for a user_id, they are `,` seperated and can have `/` for nested values.
 *
 * @property {Object} iterableKeys - The project key for Iterable.
 * @property {string} [iterableKeys.staging='<the key>'] - The project key for Iterable while in staging and testing.
 * @property {string} [iterableKeys.production='<the key>'] - The project key for Iterable while in production.
 */

/**
 * @type {AragornConfigObject}
 */
var defaultConfig = {
  /*
   * Services.
   */
  enableGTM: true,
  enableSnowplow: true,
  enableAmplitude: true,
  enableIterable: true,

  /*
   * System settings
   */
  host: 'www.weebly.com',
  api: {
    host: null,
    path: '/tracking/v2/gtmdata'
  },
  bridge: {
    parent: null,
    child: null
  },
  pageAndUserData: { // Page data and user data (returned from the API).
    pageError: ''
  },
  pageRequiresSignIn: false,
  ignoreIFrame: false,
  debug: false,
  timeout: 2000,
  throwErrorsInDebug: true,
  throwErrorsGuard: 'weebly.com',
  enableSnowplowInIFrame: false,
  sentryDNS: 'https://83db7b920b0146029954653a628d0e2d@sentry.io/1374788',

  /*
   * Service specific settings.
   */
  /* GTM */
  gtmName: 'weebly',

  /* Snowplow */
  snowplowName: '_wsp',
  snowplowNamespace: '_w',
  snowplowAppID: 'w1',
  snowplowUserIDFields: 'userID,duid',

  /* Amplitude */
  amplitudeKey: '2cff1f37ded3941acd579dea0c7cf22c',
  amplitudeUserIDFields: 'userID',

  /* Iterable */
  iterableKeys: {
    staging: '1943b5fc-b115-48fb-bd2d-01ef537dae12',
    production: '4b92005b-d3ce-496c-b41c-ad0c78fedb1e'
  }
};

/**
 * Clone and merge a config with the default values.
 *
 * @param {AragornConfigObject} config - The object to merge with the default values.
 * @returns {AragornConfigObject}
 */
function cloneAndMergeConfig(config) {
  // Deleting null (and undefined) properties from config parameter to leave default values
  var configCopy = (0, _shared.safeClone)(config);
  Object.keys(configCopy).forEach(function (key) {
    return configCopy[key] == null && delete configCopy[key];
  });

  /*
   * Take the config and merge it with the default values.
   * This is used for setting up the AragornAnalytics instance.
   */
  var configInternal = _extends({}, defaultConfig, configCopy);

  /*
   * remove any protocol provided and add leading slashes
   */
  configInternal.host = (0, _shared.ensureLeadingSlashes)(configInternal.host);

  /*
   * If no API host is provided then default to the main host.
   */
  configInternal.api.host = (0, _shared.formatHostOrDefault)(configInternal.api.host, configInternal.host);

  /*
   * If no bridge parent is provided then default to the main host.
   */
  configInternal.bridge.parent = (0, _shared.formatHostOrDefault)(configInternal.bridge.parent, configInternal.host, 'https');

  /*
   * If no bridge child is provided then default to the main host.
   */
  configInternal.bridge.child = (0, _shared.formatHostOrDefault)(configInternal.bridge.child, configInternal.host, 'https');

  return configInternal;
}

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasProp = Object.prototype.hasOwnProperty;

function throwsMessage(err) {
	return '[Throws: ' + (err ? err.message : '?') + ']';
}

function safeGetValueFromPropertyOnObject(obj, property) {
	if (hasProp.call(obj, property)) {
		try {
			return obj[property];
		} catch (err) {
			return throwsMessage(err);
		}
	}

	return obj[property];
}

function ensureProperties(obj) {
	var seen = []; // store references to objects we have seen before

	function visit(obj) {
		if (obj === null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
			return obj;
		}

		if (seen.indexOf(obj) !== -1) {
			return '[Circular]';
		}
		seen.push(obj);

		if (typeof obj.toJSON === 'function') {
			try {
				var fResult = visit(obj.toJSON());
				seen.pop();
				return fResult;
			} catch (err) {
				return throwsMessage(err);
			}
		}

		if (Array.isArray(obj)) {
			var aResult = obj.map(visit);
			seen.pop();
			return aResult;
		}

		var result = Object.keys(obj).reduce(function (result, prop) {
			// prevent faulty defined getter properties
			result[prop] = visit(safeGetValueFromPropertyOnObject(obj, prop));
			return result;
		}, {});
		seen.pop();
		return result;
	}

	return visit(obj);
}

module.exports = function (data, replacer, space) {
	return JSON.stringify(ensureProperties(data), replacer, space);
};

module.exports.ensureProperties = ensureProperties;

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExtendableError2 = __webpack_require__(27);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SystemError = function (_ExtendableError) {
  _inherits(SystemError, _ExtendableError);

  /**
   * @extends {ExtendableError}
   * @param {string} message - The error message.
   * @param {Object} [extra] - Additional details.
   */
  function SystemError(message, extra) {
    _classCallCheck(this, SystemError);

    var _this = _possibleConstructorReturn(this, (SystemError.__proto__ || Object.getPrototypeOf(SystemError)).call(this, message));

    _this.name = 'SystemError';
    _this.extra = extra;

    _this.shouldLogToSentry = true;
    _this.sentryError = new _ExtendableError3.default();
    _this.sentryError.name = _this.name + ': ' + _this.message;
    _this.sentryError.message = JSON.stringify(_this.extra, null, 2);
    return _this;
  }

  return SystemError;
}(_ExtendableError3.default);

exports.default = SystemError;

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g = function () {
	return this;
}();

// This works in non-strict mode


try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ })

/******/ })});;